// ### Imports
// * Import lib
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// * Import selectors & actions
import {
  updateReportData,
  updateTemplateData,
  updateOwnersData,
  updateMyAppsData,
} from "../../redux/slice/dataSlice";

// * Import utils
import {
  fetchReports,
  fetchTemplateData,
  fetchOwnersData,
  getMyAppsData,
  updateApplications,
} from "../../services/api";

// # Custom Hook
export const useFetchMyAppsData = () => {
  const dispatch = useDispatch();
  const reportData = useSelector((state) => state.data.reportData);
  const userFilters = useSelector((state) => state.selections.userFilters);

  useEffect(() => {
    const getReports = async () => {
      try {
        dispatch(
          updateReportData({
            result: [],
            status: "loading",
            message: "",
          })
        );

        const response = await updateApplications({
          payload: { app_filters: userFilters.app_filters },
        });

        dispatch(
          updateReportData({
            result: response.data.data,
            status: "success",
            message: response?.message || "",
          })
        );
      } catch (error) {
        dispatch(
          updateReportData({
            result: [],
            status: "error",
            message: error?.error,
          })
        );
        console.log("error", error?.error);
      }
    };
    getReports();

    // Cleanup task
    return () => {};
  }, [dispatch]);

  return {
    reportData: reportData.result,
    status: reportData.status,
    message: reportData.message,
  };
};

export const useFetchTemplateData = () => {
  const dispatch = useDispatch();
  const templateData = useSelector((state) => state.data.templateData);

  useEffect(() => {
    const getTemplateData = async () => {
      try {
        dispatch(
          updateTemplateData({
            result: [],
            status: "loading",
            message: "",
          })
        );

        const response = await fetchTemplateData();

        dispatch(
          updateTemplateData({
            result: response.data.data,
            status: "success",
            message: response?.message || "",
          })
        );
      } catch (error) {
        dispatch(
          updateTemplateData({
            result: [],
            status: "error",
            message: error?.error,
          })
        );
        console.log("error", error?.error);
      }
    };
    getTemplateData();

    // Cleanup task
    return () => {
      // dispatch(
      //   updateTemplateData({
      //     result: [],
      //     status: "loading",
      //     message: "",
      //   })
      // );
    };
  }, [dispatch]);

  return {
    templateData: templateData.result,
    templateStatus: templateData.status,
    templateMessage: templateData.message,
  };
};

export const useFetchOwnersData = () => {
  const dispatch = useDispatch();
  const ownersData = useSelector((state) => state.data.ownersData);

  useEffect(() => {
    const getData = async () => {
      try {
        dispatch(
          updateOwnersData({
            result: [],
            status: "loading",
            message: "",
          })
        );

        const response = await fetchOwnersData();

        dispatch(
          updateOwnersData({
            result: response.data.data,
            status: "success",
            message: response?.message || "",
          })
        );
      } catch (error) {
        dispatch(
          updateOwnersData({
            result: [],
            status: "error",
            message: error?.error,
          })
        );
        console.log("error", error?.error);
      }
    };
    getData();

    // Cleanup task
    return () => {
      dispatch(
        updateOwnersData({
          result: [],
          status: "loading",
          message: "",
        })
      );
    };
  }, [dispatch]);

  return {
    ownersData: ownersData.result,
    ownersStatus: ownersData.status,
    ownersMessage: ownersData.message,
  };
};

export const useFetchMyApps = ({ app_sub_type }) => {
  const dispatch = useDispatch();
  const myData = useSelector((state) => state.data.myData);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    const getData = async () => {
      try {
        dispatch(
          updateMyAppsData({
            result: {},
            status: "loading",
            message: "",
          })
        );

        const response = await getMyAppsData({
          params: {
            app_sub_type:
              app_sub_type === "Data Asset" ? "dataset" : app_sub_type,
          },
          signal,
        });

        dispatch(
          updateMyAppsData({
            result: { ...response.data.data },
            status: "success",
            message: response?.message || "",
          })
        );
      } catch (error) {
        if (error.name !== "TypeError") {
          console.log("error form api", error);
          if (error.name !== "CanceledError")
            dispatch(
              updateMyAppsData({
                result: {},
                status: "error",
                message: error?.error,
              })
            );
        }
      }
    };
    getData();

    // Cleanup task
    return () => {
      abortController.abort();
    };
  }, [dispatch, app_sub_type]);

  return {
    myData: myData.result,
    myDataStatus: myData.status,
    myDataMessage: myData.message,
  };
};
